import React, { useEffect, useState } from "react";
import { AsyncCreateEntry } from '../providers/dataProvider';
import urls from "../constants";

export const useListPriceCalculation = ({
  variantsArray, setvariantsarray, setSalesMultiplier, AddNewEntry, addProduct, setAddProduct, productConfig, configSetting, setErrorMessage, userMultiplier, lastKey, setLastKey, setHasUnsavedChanges
}) => {
  const [listPriceMessage, setListPriceMessage] = useState(null);

  const HandleProductOnChange = async (item, productindex, markDirty = true) => {
    if (markDirty) {
      setHasUnsavedChanges(true)
    }
    let resourceObj = {};

    if (productConfig?.productName?.productGroupId === urls?.LINEAR_GROUP_ID) {
      if (productConfig?.productName?.productSubGroupId === urls?.CURVED_LINEARSLOT_DIFF_USER_PRODUCT_ID)
        resourceObj = CalculateCurvedLSD(item)
      else if (productConfig?.productName?.productSubGroupId === urls?.MITTER_CORNER_LAD_PRODUCT_ID)
        resourceObj = CalculateMiterCornerLAD(item)
      else
        resourceObj = CalculateListPrice(item);
    }
    else if (productConfig?.productName?.productGroupId === urls?.CEILING_GROUP_ID) {
      resourceObj = CalculateCeilingListPrice(item);
    } else if (productConfig?.productName?.productGroupId === urls?.DEFLECTION_GROUP_ID) {
      resourceObj = CalculateDeflectionListPrice(item);
    } else if (productConfig?.productName?.productGroupId === urls?.EXHAUST_GROUP_ID) {
      resourceObj = CalculateExhauseGrillListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.EGGCRATE_GROUP_ID) {
      resourceObj = CalculateEggCrateGrillListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.TRANSFER_GROUP_ID) {
      resourceObj = CalculateTransferGrillListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.PERFORATED_GROUP_ID) {
      resourceObj = CalculatePerforatedListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.CIRCULAR_DIFF_GROUP_ID) {
      resourceObj = CalculateCircularListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.JET_DIFF_GROUP_ID) {
      resourceObj = CalculateJetListPrice(item)
    } else if (productConfig?.productName?.productSubGroupId === urls?.NOZZLE_PRODUCT_ID) {
      resourceObj = CalculateNozzleListPrice(item)
    } else if (productConfig?.productName?.productSubGroupId === urls?.PUNKAH_NOZZLE_PRODUCT_ID) {
      resourceObj = CalculatePunKahNozzleListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.LINEARBAR_GRILL_GROUP_ID) {
      if (productConfig?.productName?.productSubGroupId === urls?.LINEAR_BAR_PRODUCT_ID)
        resourceObj = CalculateLinearBarListPrice(item)
      else if (productConfig?.productName?.productSubGroupId === urls?.CURVED_LINEARBAR_GRILL_PRODUCT_ID)
        resourceObj = CalculateCurvedLBGrillListPrice(item)
      else if (productConfig?.productName?.productSubGroupId === urls?.MITER_CORNER_PRODUCT_ID)
        resourceObj = CalculateMiterCornerListPrice(item)
    }
    else if (productConfig?.productName?.productGroupId === urls?.FLOW_BAR_DIFF_GROUP_ID) {
      if (productConfig?.productName?.productSubGroupId === urls?.CURVED_FBD_PRODUCT_ID)
        resourceObj = CalculateCurvedFBD(item)
      else if (productConfig?.productName?.productSubGroupId === urls?.MITTER_CORNER_FLOW_BAR_PRODUCT_ID)
        resourceObj = CalculateMiterCornerFBD(item)
      else
        resourceObj = CalculateFlowBarListPrice(item)
    }
    else if (productConfig?.productName?.productGroupId === urls?.DISC_VALVES_GROUP_ID) {
      resourceObj = CalculateDiscValvesListPrice(item);
    } else if (productConfig?.productName?.productGroupId === urls?.FIRE_DAMPER_GROUP_ID) {
      resourceObj = CalculateCurtainFireDamperListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.DUCT_ACCESS_DOORS) {
      resourceObj = CalculateDuctAccessDoorDamperListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.COMBINATION_FIRE_SMOKE_GROUP_ID) {
      resourceObj = CalculateCombinationFireSmokeDamperListPrice(item)
    } else if (productConfig?.productName?.productGroupId === urls?.SMOKE_DAMPER_GROUP_ID) {
      resourceObj = CalculateSmokeDamperListPrice(item)
    }
    else if (productConfig?.productName?.productGroupId === urls?.STEEL_CONTROL_DAMPER) {
      if (urls?.ROUND_VOLUME_CONTROL_PRODUCT_IDS?.includes(productConfig?.productName?.productSubGroupId))
        resourceObj = CalculateRoundVolumeControlListPrice(item)
    }
    else if (productConfig?.productName?.productGroupId === urls?.FRESH_AIR_LOUVERS_GROUP_ID) {
      if (productConfig?.productName?.productSubGroupId === urls?.FRESH_AIR_LOUVERS_PRODUCT_ID)
        resourceObj = CalculateFreshAirLouversListPrice(item)
      else if (productConfig?.productName?.productSubGroupId === urls?.SAND_TRAP_LOUVERS_PRODUCT_ID)
        resourceObj = CalculateSandTrapLouversListPrice(item)

    } else if (productConfig?.productName?.productGroupId === urls?.VAV_GROUP_ID) {
      resourceObj = CalculateBypassVavListPrice(item);
    }
    else if (productConfig?.productName?.productGroupId === urls?.PRESSURE_VAV_GROUP_ID) {
      resourceObj = CalculatePressureIndependentVavListPrice(item);
    }

    if (resourceObj?.resource) {
      const result = await AsyncCreateEntry(
        resourceObj?.resource,
        resourceObj?.inputObj,
        resourceObj?.item,
        resourceObj?.item
      );

      const actualQty = variantsArray?.find(
        v => v.sid === resourceObj?.item?.sid &&
          urls.QUANTITY_CONSTANT.includes(v.variantId)
      );
      result.quantity = parseFloat(actualQty?.variantValue) || 1;

      if (result?.status === 200 && result?.successData?.[0]?.costingToken) {
        setAddProduct(prev => prev.map(item =>
          item.sid === resourceObj?.item?.sid
            ? { ...item, costingToken: result.successData[0].costingToken }
            : item
        ));
      }

      setListPriceMessage(result)
      HandleListPriceResult(result)
    }
  };

  useEffect(() => {
    let index = (((addProduct?.findIndex(item => item?.sid === listPriceMessage?.message?.sid)) * 1) + 1)
    if (index === addProduct?.length && urls.QUANTITY_CONSTANT.includes(listPriceMessage?.message?.variantId) && lastKey === "Tab") {
      AddNewEntry();
    }
    setLastKey("")
  }, [variantsArray, listPriceMessage])

  const getVariantValue = (sid, variantId) => {
    const variant = variantsArray?.find(i => i.sid === sid && variantId.includes(i.variantId));
    return variant ? variant.variantValue?.toString() : null;
  };

  const CalculateListPrice = (item) => {
    const length = getVariantValue(item.sid, urls.LENGTH) || 0;
    const slot = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const endcap = getVariantValue(item.sid, urls.END_CAPS) || "";
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    const bopLength = getVariantValue(item?.sid, urls?.BOP_LENGTHS) || 0;

    if (length && slot && endcap && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length,
        slots: slot,
        endcaps: endcap,
        quantity: parseFloat(quantity),
        slotWidth: configSetting.find(i => i.attributeId === urls.SLOT_WIDTH)?.valueName || "",
        type: configSetting.find(i => i.attributeId === urls.TYPE)?.valueName || "",
        identityId: localStorage.getItem("authidentity"),
        ralColor: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "None",
        blankOffPlate: configSetting.find(i => i.attributeId === urls.BANK_OF_BLATE)?.valueName || "",
        blankOffPlateLength: bopLength || 0,
      };
      return {
        resource: "listprice", inputObj, item
      }
    } else return null;
  };

  const CalculateCurvedLSD = (item) => {
    const length = getVariantValue(item.sid, urls.ARC_LENGTH) || 0;
    const slots = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const endCaps = getVariantValue(item.sid, urls.END_CAPS) || "";
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    const arcRadious = getVariantValue(item?.sid, urls?.ARC_RADIOUS) || 0;
    const bopLength = getVariantValue(item?.sid, urls?.BOP_LENGTHS) || 0;
    if (length && slots && endCaps && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length,
        slots,
        endCaps,
        arcRadious,
        quantity: parseFloat(quantity),
        slotWidth: configSetting.find(i => i.attributeId === urls.SLOT_WIDTH)?.valueName || "",
        curvatureType: configSetting.find(i => i.attributeId === urls.CURVATURE_TYPE)?.valueName,
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        blankOffPlate: configSetting.find(i => i.attributeId === urls.BANK_OF_BLATE)?.valueName || "",
        blankOffPlateLength: bopLength || 0,
        identityId: localStorage.getItem("authidentity"),
      };
      return {
        resource: "curvedlinearslotlistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateCurvedFBD = (item) => {
    const length = getVariantValue(item.sid, urls.ARC_LENGTH) || 0;
    const slots = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const endCaps = getVariantValue(item.sid, urls.END_CAPS) || "";
    const endcaps = getVariantValue(item.sid, urls.END_CAPS) || "";
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (length && slots && endCaps && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length,
        slots,
        identityId: localStorage.getItem("authidentity"),
        endcaps,
        quantity: parseFloat(quantity),
        frame: configSetting.find(i => i.attributeId === urls.FRAME)?.valueName || "None",
        type: configSetting.find(i => i.attributeId === urls.CURVATURE_TYPE)?.valueName || "None",
        slotWidth: configSetting.find(i => i.attributeId === urls.SLOT_WIDTH)?.valueName || "None",
        hangerClip: configSetting.find(i => i.attributeId === urls.HANGER_CLIP)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
      };
      return {
        resource: "curvedflowbarlistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateCeilingListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width: parseInt(width),
        height: parseInt(height),
        quantity: parseFloat(quantity),
        transition: configSetting.find(i => urls.TRANSITION.includes(i.attributeId))?.valueName || "None",
        neckAppearance: configSetting.find(i => i.attributeId === urls.NECK_APPEARANCE)?.valueName || "None",
        throwPattern: configSetting.find(i => i.attributeId === urls.THROW_PATTERN)?.valueName || "None",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return { resource: "ceilinglistprice", inputObj, item }
    } else return null;
  };

  const CalculateDeflectionListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width,
        height,
        quantity: parseFloat(quantity),
        material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        sizingSelected: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        bladeSpacing: configSetting.find(i => i.attributeId === urls.BLADE_SPACING)?.valueName || "None",   // attributeId: 60
        bladeOrientation: configSetting.find(i => i.attributeId === urls.BLADE_ORIENTATION)?.valueName || "None", // attributeId: 61
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "None",
        userId: localStorage.getItem("authidentity") || "",
        ralColor: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return {
        resource: "deflectionlistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateExhauseGrillListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;

    let quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (urls.QUANTITY_CONSTANT.includes(item?.variantId)) {
      quantity = item?.variantValue || 0;
    }

    if (width && height) {
      const bladeOrientation = configSetting.find(i => i.attributeId === urls.BLADE_ORIENTATION)?.valueName || ""; // default value

      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width,
        height,
        quantity: parseFloat(quantity),
        material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        bladeOrientation,
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "None",
        ralColor: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return {
        resource: "exhaustgrillelistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateEggCrateGrillListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;

    let quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (urls.QUANTITY_CONSTANT.includes(item?.variantId)) {
      quantity = item?.variantValue || 0;
    }

    if (width && height) {
      const bladeSpacing = configSetting.find(i => i.attributeId === urls.BLADE_SPACING)?.valueName || "None";
      const bladeOrientation = configSetting.find(i => i.attributeId === urls.BLADE_ORIENTATION)?.valueName || "None";

      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width,
        height,
        quantity: parseFloat(quantity),
        material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "",
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "",
        ...(bladeSpacing && { bladeSpacing }),
        ...(bladeOrientation && { bladeOrientation }),
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "",
        ralColor: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };

      return {
        resource: "eggcrategrillelistprice",
        inputObj,
        item
      }
    } return null;
  };

  const CalculateTransferGrillListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width: parseInt(width),
        height: parseInt(height),
        quantity: parseFloat(quantity),
        sizingSelected: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity")
      };
      return {
        resource: "transfergrilllistprice",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculatePerforatedListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width,
        height,
        quantity: parseFloat(quantity),
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "",
        type: configSetting.find(i => i.attributeId === urls.TYPE_OF_COATING)?.valueName || "",
        installation: configSetting.find(i => i.attributeId === urls.INSTALLATION)?.valueName || "",
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return { resource: "perforatedlistprice", inputObj, item }
    } else return null;
  };

  const CalculateCircularListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.DIAMETER) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (diameter) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        diameter,
        type: configSetting.find(i => i.attributeId === urls.TYPE)?.valueName || "None",
        quantity: parseFloat(quantity),
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        butterflyDamper: configSetting.find(i => i.attributeId === urls.BUTTERFLY_DAMPER)?.valueName || "None",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return { resource: "circularlistprice", inputObj, item }
    } else return null;
  };

  const CalculateJetListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.DIAMETER) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (diameter) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        noOfNozzles: configSetting.find(i => i.attributeId === urls.NO_OF_NOZZLES)?.valueName || "None",
        diameter,
        mountingPlateMaterial: configSetting.find(i => i.attributeId === urls.MOUNTING_PLATE_MATERIAL)?.valueName || "None",
        quantity: parseFloat(quantity),
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return { resource: "jetlistprice", inputObj, item }
    } else return null;
  };

  const CalculateNozzleListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.DIAMETER) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (diameter) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        diameter,
        noOfNozzles: configSetting.find(i => i.attributeId === urls.NO_OF_NOZZLES)?.valueName || "None",
        quantity: parseFloat(quantity),
        mountingPlateMaterial: configSetting.find(i => i.attributeId === urls.MOUNTING_PLATE_MATERIAL)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return { resource: "nozzlelistprice", inputObj, item }
    } else return null;
  };
  const CalculatePunKahNozzleListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.DIAMETER) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (diameter) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        diameter,
        quantity: parseFloat(quantity),
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return { resource: "punkahnozzlelistprice", inputObj, item }
    } else return null;
  };
  const CalculateLinearBarListPrice = (item) => {
    const length = getVariantValue(item.sid, urls.LENGTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (length && height && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length,
        height,
        sizingSelected: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        constructionType: configSetting.find(i => i.attributeId === urls.CONSTRUCTION_TYPE)?.valueName || "None",
        identityId: localStorage.getItem("authidentity"),
        quantity: parseFloat(quantity),
        opposedBladeDamper: configSetting.find(i => i.attributeId === urls.OPPOSED_BLADE_DAMPER)?.valueName || "None",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
      };
      return {
        resource: "linearbarlistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateCurvedLBGrillListPrice = (item) => {
    const length = getVariantValue(item.sid, urls.ARC_LENGTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (length && height && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length,
        height,
        identityId: localStorage.getItem("authidentity"),
        quantity: parseFloat(quantity),
        bladeDeflection: configSetting.find(i => i.attributeId === urls.DEFLECTION_ANGLE)?.valueName || "None",
        curvatureType: configSetting.find(i => i.attributeId === urls.CURVATURE_TYPE)?.valueName || "None",
        sizingSelected: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        // sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "",
        // materialOfConst: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "None",
        // material: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "",
        // userId: localStorage.getItem("authidentity"),
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
      };
      return {
        resource: "curvedLBGlistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateMiterCornerListPrice = (item) => {
    const length1 = getVariantValue(item.sid, urls.LENGTH_1) || 0;
    const length2 = getVariantValue(item.sid, urls.LENGTH_2) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const miterCornerAngle = getVariantValue(item.sid, urls.ANGLE) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (length1 && length2 && height && miterCornerAngle && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length1: parseFloat(length1),
        length2: parseFloat(length2),
        height: parseFloat(height),
        miterCornerAngle: parseFloat(miterCornerAngle),
        quantity: parseFloat(quantity),
        bladeDeflection: configSetting.find(i => i.attributeId === urls.DEFLECTION_ANGLE)?.valueName || "None",
        constructionType: configSetting.find(i => i.attributeId === urls.CONSTRUCTION_TYPE)?.valueName || "None",
        miterType: configSetting.find(i => i.attributeId === urls.MITER_TYPE)?.valueName || "None",
        identityId: localStorage.getItem("authidentity"),
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName,
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
      };
      return {
        resource: "mitercornerlistprice",
        inputObj,
        item
      }
    } else return null
  };

  const CalculateMiterCornerFBD = (item) => {
    const length1 = getVariantValue(item.sid, urls.LENGTH_1) || 0;
    const length2 = getVariantValue(item.sid, urls.LENGTH_2) || 0;
    const slots = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (length1 && length2 && slots && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length1,
        length2,
        slots,
        identityId: localStorage.getItem("authidentity"),
        quantity: parseFloat(quantity),
        frame: configSetting.find(i => i.attributeId === urls.FRAME_TYPE)?.valueName || "None",
        slotWidth: configSetting.find(i => i.attributeId === urls.SLOT_WIDTH)?.valueName || "",
        miterType: configSetting.find(i => i.attributeId === urls.MITER_TYPE)?.valueName || "None",
        hangerClip: configSetting.find(i => i.attributeId === urls.HANGER_CLIP)?.valueName || "None",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
      };
      return {
        resource: "mitercornerFBDlistprice",
        inputObj,
        item
      }
    } else return null
  };

  const CalculateMiterCornerLAD = (item) => {
    const length1 = getVariantValue(item.sid, urls.LENGTH_1) || 0;
    const length2 = getVariantValue(item.sid, urls.LENGTH_2) || 0;
    const slots = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    const angle = getVariantValue(item?.sid, urls?.ANGLE) || 0;
    if (length1 && length2 && slots && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length1,
        length2,
        slots,
        angle,
        quantity: parseFloat(quantity),
        model: productConfig?.productName?.productName,
        // frame: configSetting.find(i => i.attributeId === urls.FRAME)?.valueName || "None",
        slotWidth: configSetting.find(i => i.attributeId === urls.SLOT_WIDTH)?.valueName || "",
        miterType: configSetting.find(i => i.attributeId === urls.MITER_TYPE)?.valueName || "None",
        // hangerClip: configSetting.find(i => i.attributeId === urls.HANGER_CLIP)?.valueName || "None",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        identityId: localStorage.getItem("authidentity")
      };
      return {
        resource: "mitercornerLSDlistprice",
        inputObj,
        item
      }
    } else return null;
  };

  const CalculateFlowBarListPrice = (item) => {
    const length = getVariantValue(item.sid, urls.LENGTH) || 0;
    const slot = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const endCap = getVariantValue(item.sid, urls.END_CAPS) || "";
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    const slots = getVariantValue(item.sid, urls.NO_OF_SLOTS) || 0;
    const endcaps = getVariantValue(item.sid, urls.END_CAPS) || "";
    const bopLength = getVariantValue(item?.sid, urls?.BOP_LENGTHS) || 0;
    if (length && slot && endCap && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        length,
        slots,
        endcaps,
        quantity: parseFloat(quantity),
        identityId: localStorage.getItem("authidentity"),
        frame: configSetting.find(i => i.attributeId === urls.FRAME_TYPE)?.valueName || "None",
        type: configSetting.find(i => i.attributeId === urls.TYPE)?.valueName || "None",
        slotWidth: configSetting.find(i => i.attributeId === urls.SLOT_WIDTH)?.valueName || "",
        hangerClip: configSetting.find(i => i.attributeId === urls.HANGER_CLIP)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        blankOffPlate: configSetting.find(i => i.attributeId === urls.BANK_OF_BLATE)?.valueName || "",
        blankOffPlateLength: bopLength || 0,
      };
      return {
        resource: "flowbarlistprice",
        inputObj,
        item
      }
    } return null;
  };

  const CalculateDiscValvesListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.DIAMETER) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (diameter && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        diameter,
        identityId: localStorage.getItem("authidentity"),
        ralColour: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "",
        quantity: parseFloat(quantity),
      };
      return {
        resource: "discvalves",
        inputObj,
        item
      }
    } else return null
  };

  const CalculateCurtainFireDamperListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const sleeveLength = getVariantValue(item.sid, urls.SLEEVE_LENGTH) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        modelId: productConfig?.productName?.productId || 0,
        identityId: localStorage.getItem("authidentity") || "",
        width: parseInt(width),
        height: parseInt(height),
        quantity: parseFloat(quantity),
        type: configSetting.find(i => i.attributeId === urls.CFD_TYPE)?.valueName || "None",
        installation: configSetting.find(i => i.attributeId === urls.INSTALLATION)?.valueName || "None",
        material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        application: configSetting.find(i => i.attributeId === urls.APPLICATION)?.valueName || "None",
        velocity: configSetting.find(i => i.attributeId === urls.VELOCITY_RATING)?.valueName || "None",
        pressureRating: configSetting.find(i => i.attributeId === urls.PRESSURE_RATING)?.valueName || "None",
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "",
        fusibleLink: configSetting.find(i => i.attributeId === urls.CFD_FUSIBLE_LINK_RATING)?.valueName || "None",
        sleeveThickness: configSetting.find(i => i.attributeId === urls.SLEEVE_THICKNESS)?.valueName || "None",
        sleeveLength: parseInt(sleeveLength) || 300,
        damper: configSetting.find(i => i.attributeId === urls.CFD_CLOSURE)?.valueName || "None",
        transition: configSetting.find(i => i.attributeId === urls.CFD_TRANSITION_TYPE)?.valueName || "None",
        accessories: configSetting.find(i => i.attributeId === urls.CFD_ACCESSORIES)?.valueName || "None",
        mountingInstallation: configSetting.find(i => i.attributeId === urls.CFD_MOUNT)?.valueName || "None",
        ductConnection: configSetting.find(i => i.attributeId === urls.CFD_DUCT)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
      };

      return {
        resource: "curtainfiredamperlistprice",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculateDuctAccessDoorDamperListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        width,
        height,
        quantity: parseInt(quantity),
        identityId: localStorage.getItem("authidentity"),
        insulationMaterial: configSetting.find(i => i.attributeId === urls.INSULATION_MATERIAL)?.valueName || "None",
        insulationThickness: configSetting.find(i => i.attributeId === urls.INSULATION_THICKNESS)?.valueName || "None",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "None",
        materialThickness: configSetting.find(i => i.attributeId === urls.MATERIAL_THICKNESS)?.valueName || "None",
        hinges: configSetting.find(i => i.attributeId === urls.HINGES)?.valueName || "None",
        handle: configSetting.find(i => i.attributeId === urls.HANDLE)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
      };
      return {
        resource: "ductaccessfoordamperlistprice",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculateRoundVolumeControlListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.DIAMETER) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (diameter && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId,
        // modelName: productConfig?.productName?.productName || "",
        // material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "",
        frameThickness: configSetting.find(i => i.attributeId === urls.FRAME_THICKNESS)?.valueName || "",
        bladeThickness: configSetting.find(i => i.attributeId === urls.BLADE_THICKNESS)?.valueName || "",
        // bearings: configSetting.find(i => i.attributeId === urls.BEARINGS)?.valueName || "",
        diameter,
        identityId: localStorage.getItem("authidentity"),
        quantity: parseInt(quantity),
        // userId: localStorage.getItem("authidentity") || "",
        materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_CONSTRUCTION)?.valueName || "",
        bearing: configSetting.find(i => i.attributeId === urls.BEARINGS)?.valueName || "",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
      };
      return {
        resource: "roundcontrolvolumelistprice",
        inputObj,
        item
      }
    } else return null
  };

  const CalculateCombinationFireSmokeDamperListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const transitionType = getVariantValue(item?.sid, urls?.CFSD_TRANSITION_TYPE) || "None"
    const actuatorLocation = getVariantValue(item?.sid, urls?.ACTUATOR_LOCATION) || "None"

    const sleeveLength = configSetting.find(i => i.attributeId === urls.CFSD_SLEEVE_LENGTH_ATTR)?.valueName || 0;
    const orderQuantity = 1;
    // const orderQuantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        ductWidth: parseInt(width),
        ductHeight: parseInt(height),
        orderQuantity: orderQuantity,
        //orderQuantity: parseInt(orderQuantity) || 0,
        sleeveLength: parseInt(sleeveLength) || 0,
        modelId: productConfig?.productName?.productId || 0,

        model: productConfig?.productName?.productName || "",
        mountingOrientation: configSetting.find(i => i.attributeId === urls.CFSD_MOUNTING_ORIENTATION)?.valueName || "None",
        temperatureRating: configSetting.find(i => i.attributeId === urls.CFSD_TEMPERATURE_CLASS)?.valueName || "None",
        material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        velocityRating: configSetting.find(i => i.attributeId === urls.VELOCITY_RATING)?.valueName || "None",
        pressureRating: configSetting.find(i => i.attributeId === urls.PRESSURE_RATING)?.valueName || "None",
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        bearingMaterial: configSetting.find(i => i.attributeId === urls.CFSD_BEARING_MATERIAL)?.valueName || "None",
        axleMaterial: configSetting.find(i => i.attributeId === urls.CFSD_AXLE_MATERIAL)?.valueName || "None",
        jackShaft: configSetting.find(i => i.attributeId === urls.CFSD_JACKSHAFT)?.valueName || "None",

        sleeveType: configSetting.find(i => i.attributeId === urls.CFSD_SLEEVE_TYPE)?.valueName || "None",
        sleeveThickness: configSetting.find(i => i.attributeId === urls.SLEEVE_THICKNESS)?.valueName || "None",
        transitionType: transitionType,
        transitionDetails: configSetting.find(i => i.attributeId === urls.CFSD_TRANSITION_DETAILS)?.valueName || "None",

        actuators: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_TYPE)?.valueName || "None",
        actuatorVoltage: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_VOLTAGE)?.valueName || "None",
        actuatorOperation: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_OPERATION)?.valueName || "None",
        actuatorAuxiliarySwitch: configSetting.find(i => i.attributeId === urls.CFSD_INTEGRAL_AUX_SWITCH)?.valueName || "None",
        actuatorLocation: actuatorLocation,
        actuatorMake: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_MAKE)?.valueName || "Honeywell",
        actuatorMount: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_MOUNT)?.valueName || "Mounted",

        closureDevice: configSetting.find(i => i.attributeId === urls.CFSD_CLOSURE_DEVICE)?.valueName || "None",
        closureTemperature: configSetting.find(i => i.attributeId === urls.CFSD_CLOSURE_TEMPERATURE)?.valueName || "None",

        smokeDetector: configSetting.find(i => i.attributeId === urls.CFSD_SMOKE_DETECTOR)?.valueName || "None",
        mountingAccessories: configSetting.find(i => i.attributeId === urls.CFSD_MOUNTING_ACCESSORIES)?.valueName || "None",
        securityBars: configSetting.find(i => i.attributeId === urls.CFSD_SECURITY_BARS)?.valueName || "None",
        jambSeal: configSetting.find(i => i.attributeId === urls.CFSD_JAMB_SEAL)?.valueName || "None",
        bladeSeal: configSetting.find(i => i.attributeId === urls.CFSD_BLADE_SEAL)?.valueName || "None",
        remoteTestbox: configSetting.find(i => i.attributeId === urls.CFSD_REMOTE_TESTBOX)?.valueName || "None",
        switchType: configSetting.find(i => i.attributeId === urls.CFSD_SWITCH_TYPE)?.valueName || "None",
        frameType: configSetting.find(i => i.attributeId === urls.CFSD_FRAME_TYPE)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        identityId: localStorage.getItem("authidentity") || "",
      };

      return {
        resource: "combinationfiresmokeDamper",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculateSmokeDamperListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const transitionType = getVariantValue(item?.sid, urls?.CFSD_TRANSITION_TYPE) || "None"
    const actuatorLocation = getVariantValue(item?.sid, urls?.ACTUATOR_LOCATION) || "None"

    const sleeveLength = configSetting.find(i => i.attributeId === urls.CFSD_SLEEVE_LENGTH_ATTR)?.valueName || 0;
    const orderQuantity = 1;
    // const orderQuantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height) {
      const inputObj = {
        ductWidth: parseInt(width),
        ductHeight: parseInt(height),
        orderQuantity: orderQuantity,
        //orderQuantity: parseInt(orderQuantity) || 0,
        sleeveLength: parseInt(sleeveLength) || 0,
        modelId: productConfig?.productName?.productId || 0,

        model: productConfig?.productName?.productName || "",
        mountingOrientation: configSetting.find(i => i.attributeId === urls.CFSD_MOUNTING_ORIENTATION)?.valueName || "None",
        temperatureRating: configSetting.find(i => i.attributeId === urls.CFSD_TEMPERATURE_CLASS)?.valueName || "None",
        material: configSetting.find(i => i.attributeId === urls.CEILING_MATERIAL)?.valueName || "None",
        velocityRating: configSetting.find(i => i.attributeId === urls.VELOCITY_RATING)?.valueName || "None",
        pressureRating: configSetting.find(i => i.attributeId === urls.PRESSURE_RATING)?.valueName || "None",
        sizing: configSetting.find(i => i.attributeId === urls.SIZING)?.valueName || "None",
        bearingMaterial: configSetting.find(i => i.attributeId === urls.CFSD_BEARING_MATERIAL)?.valueName || "None",
        axleMaterial: configSetting.find(i => i.attributeId === urls.CFSD_AXLE_MATERIAL)?.valueName || "None",
        jackShaft: configSetting.find(i => i.attributeId === urls.CFSD_JACKSHAFT)?.valueName || "None",

        sleeveType: configSetting.find(i => i.attributeId === urls.CFSD_SLEEVE_TYPE)?.valueName || "None",
        sleeveThickness: configSetting.find(i => i.attributeId === urls.SLEEVE_THICKNESS)?.valueName || "None",
        transitionType: transitionType,
        transitionDetails: configSetting.find(i => i.attributeId === urls.CFSD_TRANSITION_DETAILS)?.valueName || "None",

        actuators: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_TYPE)?.valueName || "None",
        actuatorVoltage: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_VOLTAGE)?.valueName || "None",
        actuatorOperation: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_OPERATION)?.valueName || "None",
        actuatorAuxiliarySwitch: configSetting.find(i => i.attributeId === urls.CFSD_INTEGRAL_AUX_SWITCH)?.valueName || "None",
        actuatorLocation: actuatorLocation,
        actuatorMake: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_MAKE)?.valueName || "Honeywell",
        actuatorMount: configSetting.find(i => i.attributeId === urls.CFSD_ACTUATOR_MOUNT)?.valueName || "Mounted",

        closureDevice: configSetting.find(i => i.attributeId === urls.CFSD_CLOSURE_DEVICE)?.valueName || "None",
        closureTemperature: configSetting.find(i => i.attributeId === urls.CFSD_CLOSURE_TEMPERATURE)?.valueName || "None",

        smokeDetector: configSetting.find(i => i.attributeId === urls.CFSD_SMOKE_DETECTOR)?.valueName || "None",
        mountingAccessories: configSetting.find(i => i.attributeId === urls.CFSD_MOUNTING_ACCESSORIES)?.valueName || "None",
        securityBars: configSetting.find(i => i.attributeId === urls.CFSD_SECURITY_BARS)?.valueName || "None",
        jambSeal: configSetting.find(i => i.attributeId === urls.CFSD_JAMB_SEAL)?.valueName || "None",
        bladeSeal: configSetting.find(i => i.attributeId === urls.CFSD_BLADE_SEAL)?.valueName || "None",
        remoteTestbox: configSetting.find(i => i.attributeId === urls.CFSD_REMOTE_TESTBOX)?.valueName || "None",
        switchType: configSetting.find(i => i.attributeId === urls.CFSD_SWITCH_TYPE)?.valueName || "None",
        frameType: configSetting.find(i => i.attributeId === urls.CFSD_FRAME_TYPE)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        identityId: localStorage.getItem("authidentity") || "",
      };

      return {
        resource: "smokeDamper",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculateFreshAirLouversListPrice = (item) => {
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (width && height && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId || 0,
        width: parseInt(width),
        height: parseInt(height),
        quantity: parseInt(quantity),
        screen: configSetting.find(i => i.attributeId === urls.FRESH_AIR_SCREEN)?.valueName || "None",
        filtThick: configSetting.find(i => i.attributeId === urls.FRESH_AIR_FILT_THICK)?.valueName || "None",
        outerFlange: configSetting.find(i => i.attributeId === urls.FRESH_AIR_OUTER_FLANGE)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return {
        resource: "freshairlouverslistprice",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculateSandTrapLouversListPrice = (item) => {
    const width = getVariantValue(item.sid, urls.WIDTH) || 0;
    const height = getVariantValue(item.sid, urls.HEIGHT) || 0;

    let quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    if (urls.QUANTITY_CONSTANT.includes(item?.variantId)) {
      quantity = item?.variantValue || 0;
    }

    if (width && height && quantity) {
      const inputObj = {
        modelId: productConfig?.productName?.productId || 0,
        width: parseInt(width),
        height: parseInt(height),
        quantity: parseInt(quantity),
        screen: configSetting.find(i => i.attributeId === urls.FRESH_AIR_SCREEN)?.valueName || "None",
        filtThick: configSetting.find(i => i.attributeId === urls.FRESH_AIR_FILT_THICK)?.valueName || "None",
        outerFlange: configSetting.find(i => i.attributeId === urls.FRESH_AIR_OUTER_FLANGE)?.valueName || "None",
        color: configSetting.find(i => i.attributeId === urls.RAL_COLOR)?.valueName || "None",
        identityId: localStorage.getItem("authidentity") || "",
      };
      return {
        resource: "sandtraplouverslistprice",
        inputObj,
        item
      };
    } else return null;
  };

  const CalculateBypassVavListPrice = (item) => {
    const inletDia = getVariantValue(item.sid, urls.VAV_INLET_DIA) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;
    const vavModelText = (getVariantValue(item.sid, urls.VAV_MODEL) || "").toString();
    const isBypass = vavModelText.toLowerCase().includes("bypass");

    if (!inletDia || !quantity) return null;

    const baseInputObj = {
      modelId: productConfig?.productName?.productId,
      inletDia,
      quantity: parseFloat(quantity),
      application: configSetting.find(i => i.attributeId === urls.APPLICATION)?.valueName || "None",
      materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_OF_CONSTRUCTION)?.valueName || "None",
      casingThickness: configSetting.find(i => i.attributeId === urls.VAV_CASING_THICKNESS)?.valueName || "None",
      insulationLinear: configSetting.find(i => i.attributeId === urls.INSULATION_MATERIAL)?.valueName || "None",
    };

    return {
      resource: "bypassVavListPrice",
      inputObj: baseInputObj,
      item,
    };


  };

  const CalculatePressureIndependentVavListPrice = (item) => {
    const diameter = getVariantValue(item.sid, urls.VAV_INLET_DIA) || 0;
    const quantity = getVariantValue(item.sid, urls.QUANTITY_CONSTANT) || 0;

    if (!diameter || !quantity) return null;

    const insulationThicknessRaw = configSetting.find(i => i.attributeId === urls.VAV_INSULATION_THICKNESS)?.valueName;

    const inputObj = {
      modelId: productConfig?.productName?.productId,
      diameter,
      quantity: parseFloat(quantity),
      application: configSetting.find(i => i.attributeId === urls.APPLICATION)?.valueName || "None",
      materialOfConstruction: configSetting.find(i => i.attributeId === urls.MATERIAL_OF_CONSTRUCTION)?.valueName || "None",
      casingThickness: configSetting.find(i => i.attributeId === urls.VAV_CASING_THICKNESS)?.valueName || "None",
      casingType: configSetting.find(i => i.attributeId === urls.VAV_CASING_TYPE)?.valueName || "None",
      innerWallType: configSetting.find(i => i.attributeId === urls.VAV_INNER_WALL_TYPE)?.valueName || "None",
      insulationLinear: configSetting.find(i => i.attributeId === urls.VAV_INSULATION_LINEAR)?.valueName || "None",
      insulationThickness: parseInt(insulationThicknessRaw, 10) || 0,
    };

    return {
      resource: "pressureIndependentVavListPrice",
      inputObj,
      item,
    };
  };

  const HandleListPriceResult = (priceMessage) => {
    if (priceMessage?.message?.sid > 0 && priceMessage?.status === 400) {
      let index = (((addProduct?.findIndex(item => item?.sid === priceMessage?.message?.sid)) * 1) + 1)
      setErrorMessage("Line No :" + index + " , Please check input value.");
      setvariantsarray(updateVariantsArray(priceMessage));
    }
    else if (priceMessage?.message?.sid > 0 && priceMessage?.status === 200) {
      setvariantsarray(updateVariantsArray(priceMessage));
      setErrorMessage(null);
      const productMultiplier = userMultiplier?.mlpPermissions?.find((item) => item?.productGroupId === productConfig?.productName?.productGroupId)
      // setSalesMultiplier({ minimumMlp: productMultiplier?.minimumMlp || 0, factoryMlp: priceMessage.successData?.[0]?.salesMultiplier });
      setSalesMultiplier({
        maximumDiscount: productMultiplier?.maximumDiscount
          ? 1 - productMultiplier.maximumDiscount / 100
          : 0,
        factoryMlp: priceMessage.successData?.[0]?.salesMultiplier
      });
    }
  }

  const updateVariantsArray = (message) => {
    const values = message?.successData?.[0] || {};
    const {
      listPrice = 0,
      noOfSectionsValue = "",
      noOfSections = "",
      salesMultiplier = 0,
      sectionLengthValue = "",
      faceSizeLengthValue = "",
      faceSizeWidthValue = "",
      sectionWidthValue = "",
      sectionWidth = "",
      sectionHeightValue = "",
      sectionHeight = "",
      faceSizeHeightValue = "",
      faceSizeDiameterValue = "",
      actuatorCost = 0,
      actuatorModel = "",
      actuatorQty = 0,
    } = values;

    const sid = message.message.sid;

    const productMarginRaw = addProduct?.find((p) => p?.sid === sid)?.margin;
    const marginValue =
      productMarginRaw === "" ||
        productMarginRaw === undefined ||
        productMarginRaw === null ||
        isNaN(Number(productMarginRaw))
        ? 0
        : Number(productMarginRaw);

    return (prevVariants) => {

      const quantity = parseFloat(message?.quantity) || 1;

      const listPriceNum = parseFloat(listPrice) || 0;
      const actuatorCostNum = parseFloat(actuatorCost) || 0;
      const actuatorQtyNum = parseFloat(actuatorQty) || 0;

      const unitPrice = listPriceNum + actuatorCostNum;
      const netUnitPrice = unitPrice * quantity;

      let netUnitPriceWithMargin;
      if (marginValue < 0) {
        netUnitPriceWithMargin = netUnitPrice * (1 - (-marginValue / 100));
      } else if (marginValue >= 100) {
        netUnitPriceWithMargin = 0;
      } else {
        const marginFactor = 1 - marginValue / 100;
        netUnitPriceWithMargin = netUnitPrice / marginFactor;
      }

      const getVariantValueById = (variantId, variantValue) => {
        switch (true) {
          case urls.SECTION_LENGTH_ARRAY.includes(variantId):
            return sectionLengthValue;
          case urls.NO_OF_SECTION_ARRAY.includes(variantId):
            if (noOfSections) return noOfSections?.toString();
            return noOfSectionsValue;
          case urls.LIST_PRICE_CONSTANT.includes(variantId):
            return listPriceNum > 0 ? String(listPriceNum) : "";

          case urls.NET_LIST_PRICE_CONSTANT.includes(variantId):
            return listPriceNum > 0 ? String(listPriceNum) : "";

          case urls.UNIT_PRICE_CONSTANT.includes(variantId):
            return unitPrice.toFixed(2);
          case urls.NET_UNIT_PRICE_CONSTANT.includes(variantId):
            return netUnitPriceWithMargin > 0 ? netUnitPriceWithMargin.toFixed(2) : "";

          case urls.FACE_LENGTH_ARRAY.includes(variantId):
            return faceSizeLengthValue;
          case urls.FACE_WIDTH_ARRAY.includes(variantId):
            return faceSizeWidthValue;
          case urls.FACE_HEIGHT_ARRAY.includes(variantId):
            return faceSizeHeightValue;
          case urls.SECTION_WIDTH_ARRAY.includes(variantId):
            if (sectionWidth) return sectionWidth?.toString();
            return sectionWidthValue;
          case urls.SECTION_HEIGHT_ARRAY.includes(variantId):
            if (sectionHeight) return sectionHeight?.toString();
            return sectionHeightValue;
          case urls.FACE_DIAMETER.includes(variantId):
            return faceSizeDiameterValue;
          case urls.ACTUATOR_MODEL_CONSTANT.includes(variantId):
            return actuatorModel || "-";
          case urls.ACTUATOR_QTY_CONSTANT.includes(variantId):
            return actuatorQty !== null && actuatorQty !== undefined ? actuatorQtyNum.toString() : "0";
          case urls.ACTUATOR_COST_CONSTANT.includes(variantId):
            return actuatorCost !== null && actuatorCost !== undefined ? actuatorCostNum.toFixed(2) : "0.00";
          default:
            return variantValue;
        }
      };

      return prevVariants.map((variant) =>
        variant.sid === sid
          ? {
            ...variant,
            variantValue: getVariantValueById(
              variant.variantId,
              variant.variantValue
            ),
          }
          : variant
      );
    };
  };

  return {
    HandleProductOnChange
  };
};
